/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIEditor
 */
export interface APIEditor {
    /**
     * 
     * @type {string}
     * @memberof APIEditor
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APIEditor
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APIEditor
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIEditor
     */
    lastName?: string;
}

/**
 * Check if a given object implements the APIEditor interface.
 */
export function instanceOfAPIEditor(value: object): value is APIEditor {
    return true;
}

export function APIEditorFromJSON(json: any): APIEditor {
    return APIEditorFromJSONTyped(json, false);
}

export function APIEditorFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEditor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function APIEditorToJSON(value?: APIEditor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
    };
}

